import { stepTravelDelayLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['delayInformationItems',
    'reasonsForDelay',
    'reasonsForMissedConnection',
    'missedConnectionInformationItems',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `section11.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const tripDelayExpenses = mapToTripDelayExpense(data);
  const missedConnectionExpenses = mapToMissedConnectionExpense(data);
  return [...tripDelayExpenses, ...missedConnectionExpenses];
}

function mapToTripDelayExpense(data) {
  if (data.travelDelay !== 'true' || data.delayInformationItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.travelDelay.claimCode;
  const expenses = [];

  data.delayInformationItems.forEach(
    (item) => {
      const expense = mapDelayItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapDelayItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, item.dateOfLoss, claimCode);
}

function mapToMissedConnectionExpense(data) {
  if (data.missedConnection !== 'true' || data.missedConnectionInformationItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.missedConnection.claimCode;
  const expenses = [];

  data.missedConnectionInformationItems.forEach(
    (item) => {
      const expense = mapMissedConnectionItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapMissedConnectionItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, item.dateOfLoss, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor;
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.id);
  if (!item || !item.amountClaimed || !item.currentAmountClaimed) {
    return null;
  }
  return {
    shortDescription: `${item.companyNameLoss}`,
    dateOfExpense: itemDate,
    clientCost: item.amountClaimed,
    currency: item.currentAmountClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor;
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.id);
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepTravelDelayDataMapper.js